import { ROUTES } from '#/config/routes';
import {
  createDateFilterMeta,
  createTextFilterMeta,
} from '#/modules/commonComponents/table/columnFilterMeta';
import { createDocumentNavLinksColumn } from '#/modules/commonComponents/table/tableColumnHelpers';
import TruncatedTextWithTooltip from '#/modules/commonComponents/table/TruncatedTextWithTooltip';
import {
  readCreatedAtRangeFilter,
  readUpdatedAtRangeFilter,
  resolveCreatedAtFilterChipDisplay,
  resolveUpdatedAtFilterChipDisplay,
} from '#/modules/imsMgmt/receipts/stocktake/helper/stocktakeRecordDateListFilter';
import { formatDateTimeOrDash } from '#/utils/date';

const DATE_FILTER_PLACEHOLDER = '西元年/月/日';

export function buildStocktakeColumns({
  filters = {},
  onFilterChange,
  onCreatedAtRangeChange,
  onUpdatedAtRangeChange,
  canShowEdit = (row) => row.status === 'DRAFT',
} = {}) {
  return [
    createDocumentNavLinksColumn({
      getDetailPath: (row) => ROUTES.stocktakeDetail(row.id),
      getEditPath: (row) => ROUTES.stocktakeEdit(row.id),
      canShowEdit,
    }),
    {
      header: '盤點單號',
      accessorKey: 'stocktakeNo',
      size: 140,
      enableColumnFilter: true,
      meta: createTextFilterMeta({
        key: 'stocktakeNo',
        label: '盤點單號',
        filterValue: filters.stocktakeNo,
        onChange: (value) => onFilterChange('stocktakeNo', value),
        placeholder: '搜尋盤點單號',
      }),
    },
    {
      header: '備註',
      accessorKey: 'remark',
      size: 200,
      enableSorting: false,
      enableColumnFilter: true,
      meta: {
        cellClassName: 'td_left',
        ...createTextFilterMeta({
          key: 'remark',
          label: '備註',
          filterValue: filters.remark,
          onChange: (value) => onFilterChange('remark', value),
          placeholder: '搜尋備註',
        }),
      },
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={row.original?.remark || '—'} />
      ),
    },
    {
      id: 'lineCount',
      header: '項目數',
      accessorKey: 'lineCount',
      size: 96,
      enableSorting: false,
      meta: { cellClassName: 'text-right' },
    },
    {
      id: 'createdAt',
      header: '建立時間',
      accessorFn: (row) => formatDateTimeOrDash(row.record?.createdAt),
      size: 160,
      enableSorting: false,
      enableColumnFilter: true,
      meta: createDateFilterMeta({
        key: 'createdAtFrom',
        label: '建立時間',
        mode: 'range',
        filterValue: readCreatedAtRangeFilter(filters),
        onChange: onCreatedAtRangeChange,
        placeholder: DATE_FILTER_PLACEHOLDER,
        resolveFilterDisplay: resolveCreatedAtFilterChipDisplay,
      }),
    },
    {
      id: 'updatedAt',
      header: '更新時間',
      accessorFn: (row) => formatDateTimeOrDash(row.record?.updatedAt),
      size: 160,
      enableSorting: false,
      enableColumnFilter: true,
      meta: createDateFilterMeta({
        key: 'updatedAtFrom',
        label: '更新時間',
        mode: 'range',
        filterValue: readUpdatedAtRangeFilter(filters),
        onChange: onUpdatedAtRangeChange,
        placeholder: DATE_FILTER_PLACEHOLDER,
        resolveFilterDisplay: resolveUpdatedAtFilterChipDisplay,
      }),
    },
  ];
}
